/*
  Mega-Menü v2 (Spalten)
  Öffnet und schließt die Panels per Klick, setzt aria-expanded,
  schließt per Escape, per Klick daneben und wenn der Fokus das Menü verlässt.
  Die Höhe ergibt sich aus dem Inhalt, es wird nichts berechnet.
*/
(() => {
  const nav = document.querySelector('.mmv2');
  if (!nav) return;

  let openIndex = null;

  const trigger = (i) => nav.querySelector(`.mmv2__trigger[data-mmv2-index="${i}"]`);
  const container = (i) => nav.querySelector(`[data-mmv2-container="${i}"]`);

  const close = (returnFocus = false) => {
    if (openIndex === null) return;
    const t = trigger(openIndex);
    const c = container(openIndex);
    if (t) {
      t.setAttribute('aria-expanded', 'false');
      t.classList.remove('active');
      if (returnFocus) t.focus();
    }
    if (c) {
      c.removeAttribute('open');
      const overlay = c.querySelector('[data-mmv2-overlay]');
      if (overlay) overlay.classList.remove('open');
    }
    document.body.classList.remove('overflow-hidden');
    openIndex = null;
  };

  const open = (i) => {
    close();
    const t = trigger(i);
    const c = container(i);
    if (!t || !c) return;
    t.setAttribute('aria-expanded', 'true');
    t.classList.add('active');
    c.setAttribute('open', '');
    const overlay = c.querySelector('[data-mmv2-overlay]');
    if (overlay) overlay.classList.add('open');
    document.body.classList.add('overflow-hidden');
    openIndex = i;
  };

  nav.querySelectorAll('.mmv2__trigger').forEach((t) => {
    t.addEventListener('click', (event) => {
      event.preventDefault();
      const i = t.dataset.mmv2Index;
      if (openIndex === i) {
        close();
      } else {
        open(i);
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (openIndex === null) return;
    if (event.target.closest('.mmv2__panel') || event.target.closest('.mmv2__trigger')) return;
    close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && openIndex !== null) {
      close(true);
    }
  });

  nav.addEventListener('focusout', (event) => {
    if (openIndex !== null && event.relatedTarget && !nav.contains(event.relatedTarget)) {
      close();
    }
  });
})();